import { Tabs } from "@mantine/core";
import { useNavigate } from "react-router-dom";

import Layout from "../../components/Layout/Layout";
import { useTabFromUrl } from "../../hooks/useTabFromUrl.tsx";
import CollectionDashboard from "./CollectionDashboard.tsx";
import TradeInsuranceDashboard from "./TradeInsuranceDashboard/TradeInsuranceDashboard.tsx";
import { TabValue } from "./types.ts";

export default function CollectionDashboardPage() {
  const navigate = useNavigate();

  const activeTab = useTabFromUrl({
    defaultTab: TabValue.CollectionDashboard,
    tabs: Object.values(TabValue),
  });

  return (
    <Layout>
      <Tabs
        value={activeTab}
        keepMounted={false}
        variant="pills"
        onTabChange={(value) => navigate(`?tab=${value}`)}
      >
        <Tabs.List>
          <Tabs.Tab
            key={TabValue.CollectionDashboard}
            value={TabValue.CollectionDashboard}
          >
            Collection Dashboard
          </Tabs.Tab>
          <Tabs.Tab
            key={TabValue.TradeInsuranceDashboard}
            value={TabValue.TradeInsuranceDashboard}
          >
            Trade Insurance Dashboard
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value={TabValue.CollectionDashboard}>
          <CollectionDashboard />
        </Tabs.Panel>
        <Tabs.Panel value={TabValue.TradeInsuranceDashboard}>
          <TradeInsuranceDashboard />
        </Tabs.Panel>
      </Tabs>
    </Layout>
  );
}
